const getMonthlyInterest = (interestRate: number): number => {
  const notRoundedinterestRate = ((interestRate / 100) + 1) ** (1 / 12);

  return Math.round((notRoundedinterestRate - 1) * 10000000) / 10000000;
};

export const getMonthlyPayment = (price: number, interestRate: number, numberOfPayments: number): number => {
  let monthlyPayment;

  const monthlyInterest = getMonthlyInterest(interestRate);
    
  if (monthlyInterest === 0) {
    monthlyPayment = price / numberOfPayments;
  } else {
    monthlyPayment = (price * monthlyInterest) *
        (((monthlyInterest + 1) ** numberOfPayments) / (((1 + monthlyInterest) ** numberOfPayments) - 1));
  }
  return Math.floor(monthlyPayment * 100) / 100;
};

export const getTotalAmountPayable = (monthlyPayment: number, numberOfPayments: number): number =>
  Math.round(monthlyPayment * numberOfPayments * 100) / 100;

